import * as React from "react";
const SvgFred = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 44,
	height: 12,
	viewBox: "0 0 44 12",
	fill: "none",
	...props
}, /* @__PURE__ */ React.createElement("path", {
	d: "M-0.00390625 0H9.45901V2.91411H3.27459V4.95445H8.86786V7.71445H3.27459V12H-0.00390625V0Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M10.4014 0H15.9945C17.8028 0 19.0533 0.480235 19.8476 1.3031C20.5403 1.98882 20.8954 2.91411 20.8954 4.09734V4.13144C20.8954 5.96583 19.932 7.18285 18.4618 7.81719L21.2837 12H17.4983L15.1156 8.36577H13.6794V12H10.4014V0ZM15.8425 5.76004C16.9579 5.76004 17.5999 5.21146 17.5999 4.33723V4.30314C17.5999 3.35994 16.9239 2.88002 15.8259 2.88002H13.6796V5.76004H15.8425Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M22.0117 0H31.5255V2.82865H25.2561V4.64546H30.9341V7.268H25.2561V9.17074H31.6101V12H22.0117V0Z",
	fill: "currentColor"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M32.7622 0H37.3251C41.5499 0 44.0003 2.46828 44.0003 5.93143V5.96552C44.0003 9.42852 41.5166 12 37.2579 12H32.7622V0ZM37.3748 9.05133C39.3349 9.05133 40.6368 7.95403 40.6368 6.01689V5.9828C40.6368 4.06294 39.3349 2.94867 37.3748 2.94867H36.0404V9.05149L37.3748 9.05133Z",
	fill: "currentColor"
}));
export default SvgFred;
